module.exports = __webpack_public_path__ + "img/send-hor.c68e001a.svg";